// extracted by mini-css-extract-plugin
module.exports = {"text":"PullOutBlock-module--text--179cp"};